export default __webpack_public_path__ + "static/media/emilan-mixto.34d3d793.svg";